/*
* blazingcard
* http://www.blazingcard.com
*
* Copyright (c) 2022 Kellton Tech Pvt Ltd
* Author Kellton Tech Pvt Ltd <support@blazingcard.com>
* Licensed under the MIT license.
*/
import { Map, Record } from 'immutable';

export interface CustomerLayoutState extends Map<string, any> {

  customerCount: any;
  customerCountLoading: boolean;
  customerCountLoaded: boolean;
  customerCountFailed: boolean;
}

export const CustomerLayoutStateRecord = Record({

  customerCount: {},
  customerCountLoading: false,
  customerCountLoaded: false,
  customerCountFailed: false,
});
